const DEVICE_ID_KEY = 'deviceId';

const createDeviceId = (): string => {
    if (
        typeof crypto !== 'undefined' &&
        typeof crypto.randomUUID === 'function'
    ) {
        return crypto.randomUUID();
    }

    if (
        typeof crypto !== 'undefined' &&
        typeof crypto.getRandomValues === 'function'
    ) {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);

        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;

        const hex = Array.from(bytes, byte =>
            byte.toString(16).padStart(2, '0')
        );

        return [
            hex.slice(0, 4).join(''),
            hex.slice(4, 6).join(''),
            hex.slice(6, 8).join(''),
            hex.slice(8, 10).join(''),
            hex.slice(10, 16).join(''),
        ].join('-');
    }

    return `fallback-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const getOrCreateDeviceId = (): string => {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
        id = createDeviceId();
        localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
};

export const Storage = {
    storeData: (key: string, value: string) => {
        localStorage.setItem(key, value);
    },
    storeObjData: (key: string, obj: any) => {
        localStorage.setItem(key, JSON.stringify(obj));
    },
    getObjData: <T = Record<any, any>>(key: string): T | null => {
        const value = localStorage.getItem(key);
        if (value === null) return null;
        try {
            return JSON.parse(value) as T;
        } catch (e) {
            return null;
        }
    },
    getData: (key: string) => localStorage.getItem(key),
    removeData: (key: string) => {
        localStorage.removeItem(key);
    },
};
